import { css } from "@compiled/react";

import { RichContent } from "@/templates/agile-hub/src/components/rich-content/src/rich-content";
import { ContentComponent } from "@/templates/agile-hub/types";

export type BodyTextContainerProps = {
    name: string;
    contentComponents: ContentComponent[] | null;
};

/**
 * Styles
 */

const headerCss = css({
    margin: "0",
    marginBlockEnd: "14px"
});

const contentComponentWrapperCss = css({ marginBlockEnd: "20px" });

/**
 * Render content component based on type
 */

export const BodyTextContainer = (props: BodyTextContainerProps) => {
    const { name, contentComponents } = props;

    return (
        <div key={name}>
            <h2 css={headerCss}>{name}</h2>
            {contentComponents &&
                contentComponents.map((component, idx) => (
                    <div key={idx} css={contentComponentWrapperCss}>
                        <RichContent {...component} />
                    </div>
                ))}
        </div>
    );
};
